import { render, staticRenderFns } from "./page-list.vue?vue&type=template&id=7b23add3&scoped=true&"
import script from "./page-list.vue?vue&type=script&lang=js&"
export * from "./page-list.vue?vue&type=script&lang=js&"
import style0 from "./page-list.vue?vue&type=style&index=0&id=7b23add3&lang=scss&scoped=true&"
import style1 from "./page-list.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b23add3",
  null
  
)

export default component.exports